import { NULL } from "constants/primitives";
import { _DOCUMENT_ } from "constants/dom";
import report from "./report";

// code from https://www.w3schools.com/js/js_cookies.asp
const getCookie = (cookieName: string): string | null => {
  const name = cookieName + "=";
  try {
    const cookieArray = _DOCUMENT_.cookie.split(";");
    for (let i = 0; i < cookieArray.length; i++) {
      let c = cookieArray[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return decodeURIComponent(c.substring(name.length, c.length));
      }
    }
  } catch (e) {
    report(e);
    return NULL;
  }

  return NULL;
};

export default getCookie;
